import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { TabContainer } from 'react-bootstrap';
import { Nav as BNav } from 'react-bootstrap';
import { NavItem as BNavItem } from 'react-bootstrap';
import { TabContent as BTabContent } from 'react-bootstrap';
import { TabPane as BTabPane } from 'react-bootstrap';

import colors from 'styles/_colors.css';
import './Tabs.css';

export const Tabs = props => (
  <TabContainer className={props.classes} {...props}>
    <Fragment>
      {props.children}
    </Fragment>
  </TabContainer>
);

Tabs.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.string
};

Tabs.displayName = 'Tabs';

export const Nav = props => {
  const { background, large, left, icons, ...others } = props;

  const classes = classnames(
    {
      'large': large,
      'bgColors': background,
      'withIcons': icons
    }
  );

  return (
    <div
      className={classnames('tabsWrapper', { 'left': left })}
      style={{ backgroundColor: colors[background] }}
    >
      <BNav {...others} className={classes}>
        {props.children}
      </BNav>
    </div>
  );
};

Nav.propTypes = {
  left: PropTypes.bool,
  children: PropTypes.node,
  icons: PropTypes.bool,
  large: PropTypes.bool,
  background: PropTypes.oneOf([
    'black',
    'grey',
    'red',
    'dark-red',
    'dark-blue',
    'heavy-blue',
    'dark-purple',
    'purple'
  ])
};

Nav.displayName = 'Nav';

export const NavItem = props => (
  <BNavItem {...props} />
);

NavItem.displayName = 'NavItem';

export const TabContent = (props) => (
  <BTabContent {...props} />
);

TabContent.displayName = 'TabContent';

export const TabPane = props => (
  <BTabPane {...props} />
);

TabPane.displayName = 'TabPane';



// WEBPACK FOOTER //
// ./src/uis/elements/Tabs/Tabs.js